import { routes } from "./apiRoutes";

const config = {
    routes,
    ...JSON.parse(process.env.REACT_APP_CONFIG)
};
export default config
